import {Injectable} from "@angular/core";
import {
  IssueType, MissionEditorSelectorKind, MissionIssueDto,
  MissionIssuePreviewDto, PrioritySimpleDto, ResourceProfileDto,
  StereotypeUsageDto,
  SubmitMissionIssueDto
} from "@server-models";
import {FormGroup} from "@angular/forms";
import {SharedIssueStereotypeBaseService} from "@shared/components/issues/services/stereotype/shared-issue-stereotype-base.service";
import {TCurrentIssueDto} from "@shared/components/issues/types/issue-dto.type";
import {ILocalIssueDetailData} from "@shared/components/issues/interfaces/local-issue-detail-data.interface";
import {IAdditionalDetails} from "@shared/components/issues/interfaces/additional-details.interface";

@Injectable({
  providedIn: 'root',
})
export class SharedIssueMissionService extends SharedIssueStereotypeBaseService {

  override formatReadDetailData(issueDtoType: TCurrentIssueDto, issueType: IssueType): ILocalIssueDetailData {
    const issueDtoTypeMission = issueDtoType as MissionIssueDto;
    return {
      ...this.formatBaseReadDetailData(issueDtoTypeMission, issueType),
      additionalDetails: {...this.getAdditionalFormattedData(issueDtoTypeMission)}
    };
  }

  prepareFormIssueDto(formGroup: FormGroup, templatePreviewDto: MissionIssuePreviewDto,
                      resourceDto?: ResourceProfileDto): SubmitMissionIssueDto {
    const priorityFormGroup = formGroup.get('Priority') as FormGroup;
    const resourceFromGroup = formGroup.get('Resource') as FormGroup;

    const resource = resourceFromGroup?.value ? resourceFromGroup?.value : resourceDto;
    const priority = this.getPriority(templatePreviewDto, priorityFormGroup);

    const issueStereotype: StereotypeUsageDto = templatePreviewDto.issueStereotype!;
    const customPropertyValues = this.getCustomPropertyValues(formGroup);

    return {
      title: templatePreviewDto.name,
      tenantId: issueStereotype?.tenantId,
      stereotypeId: issueStereotype?.stereotypeId,
      stereotypeRowVersion: issueStereotype?.rowVersion,
      customPropertyValues,
      priority,
      resource: resource
    };
  }

  getPriority(templatePreviewDto: MissionIssuePreviewDto, formGroup: FormGroup): PrioritySimpleDto | undefined {
    let priority;
    const priorityList = templatePreviewDto.priorities!;

    if (templatePreviewDto.editorSelectorKind === MissionEditorSelectorKind.PrioritySearch) {
      if (priorityList.length === 1) {
        priority = priorityList[0];
      } else if (formGroup) {
        priority = this.findPriorityValue(formGroup, priorityList);
      }
    }

    return priority;
  }

  findPriorityValue(priorityForm: FormGroup, priorities: PrioritySimpleDto[]): PrioritySimpleDto {
    const valueToFind = priorityForm.value;
    return priorities.find(p => p?.priorityId === valueToFind)!
  }


  getAdditionalFormattedData(issueDto: MissionIssueDto): Partial<IAdditionalDetails> {
    const missionDetail = issueDto.mission;
    const resourceDetail = issueDto.resource;
    return {
      mission: missionDetail,
      resource: resourceDetail
    };
  }
}
